import { AssessmentCentreUser, UserAssessments } from "services/assessmentCentre";
import { RequestInfo } from "store/slice/store.types";
import { Pagination } from "types/globals";
import { generateID } from "utils/utils";

export type ConvertedAssessmentCentre = {
    data: ConvertedAssessmentCentreUserData[];
    meta: Pagination;
    status: RequestInfo;
};

export type ConvertedAssessmentCentreUserData = {
    id: number;
    userName: string;
    email: string;
    linkedinId: null;
    lastActiveOn: null | Date;
    lastContactedOn: null | Date;
    optinShareData: boolean;
    enabled: boolean;
    hasPace: boolean;
    paceStatus: string;
    assessments: UserAssessments;
    teams: any[];
    checked: boolean;
};

export const convertUserAssessmentList = (data: AssessmentCentreUser[]): ConvertedAssessmentCentreUserData[] => {
    return data.map((userData) => {
        return {
            id: userData.id,
            userName: userData.name,
            email: userData.email,
            linkedinId: userData.linkedin_id,
            lastActiveOn: userData.last_active_datetime,
            lastContactedOn: userData.last_contacted_datatime,
            optinShareData: userData.optin_share_data,
            enabled: userData.enabled,
            hasPace: userData.is_pace,
            paceStatus: userData.pace_status,
            assessments: userData.user_assessments,
            teams: userData.teams.map((team) => ({ ...team, id: generateID() })),
            checked: false,
        };
    });
};
